export const config = {
  rowSelection: false,
  columns: [
    {
      title: '预约ID',
      dataIndex: 'id',
      width: 190,
      // render: 'IdRender',
    },
    {
      title: '客户姓名',
      dataIndex: 'name',
      width: 160,
      render: 'nameRender'
    },
    {
      title: '客户电话',
      dataIndex: 'phone',
      width: 140,
      render: 'checkPhone',
    },
    {
      title: '商机ID',
      dataIndex: 'trackPlanId',
      width: 190,
      render: 'clueIdRender',
    },
    {
      title: '楼盘名称',
      dataIndex: 'buildingName',
      width: 180,
      ellipsis: true,
    },
    {
      title: '公司',
      dataIndex: 'companyName',
      width: 150,
      ellipsis: true,
    },
    {
      title: '预约量房时间',
      dataIndex: 'appointmentTime',
      itemType: 'dateTime',
      width: 180,
    },
    {
      title: '量房人员',
      dataIndex: 'userName',
      width: 200,
      ellipsis: true,
    },
    {
      title: '实际量房时间',
      dataIndex: 'actualMeasureTime',
      itemType: 'dateTime',
      width: 180,
    },
    {
      title: '量房报告生成时间',
      dataIndex: 'reportGenerationTime',
      itemType: 'dateTime',
      width: 180,
    },
    {
      title: '变更次数',
      dataIndex: 'changeCount',
      width: 120,
    },
    {
      title: '取消原因',
      dataIndex: 'cancelReasonName',
      width: 180,
      ellipsis: true,
    },
    {
      title: '状态',
      dataIndex: 'status',
      render: 'stateRender',
      width: 120,
    },
    {
      title: '操作',
      dataIndex: 'status',
      width: 280,
      render: 'actionRender',
      fixed: 'right',
    },
  ],
  search: [
    {
      name: 'name',
      label: '客户姓名',
    },
    {
      name: 'phone',
      label: '客户电话',
      itemType: 'number',
    },
    {
      name: 'companyId',
      label: '分公司',
      itemType: 'select',
      key: 'id',
      labelKey: 'name',
      data: 'companyList',
      events: ['onChange:onCompanyChange'],
    },
    {
      name: 'appointmentTime',
      itemType: 'autoDate',
      showTime: true,
      placeholder: ['预约量房时间起', '止'],
      label: '预约量房时间',
    },
    {
      name: 'actualMeasureTime',
      itemType: 'autoDate',
      showTime: true,
      placeholder: ['实际量房时间起', '止'],
      label: '实际量房时间',
    },
    {
      name: 'userIdentityId',
      label: '量房人员',
      itemType: 'select',
      data: 'users',
      labelKey: 'userName',
      key: 'id',
      notFoundContent: '请选择公司或无匹配数据'
    },
    {
      name: 'status',
      label: '量房状态',
      itemType: 'select',
      data: {
        "waitingMeasure": "待量房",
        "measured": "已量房",
        "auditing": "审核中",
        "completed": "已完成",
        "canceled": "已取消"
      }
    },
    {
      name: 'cancelReason',
      label: '量房取消原因',
      itemType: 'custom',
      render: 'reasonRender'
    },
  ],
  footer: [
    {
      label: '新增量房客户',
      // auth: 'specialCodesButton1',
      type: 'primary',
      events: ['onClick:onAdd'],
    },
  ],
  batchActions: [],
}
